(function () {
    'use strict';

    angular.module("imApp").factory("sopValidService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1839,
                    parameters: parms || {}
                });
            },
            listSopValids: function (parms) {
                return $ihttp.post({
                    method: 1840,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 1841,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
